import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, IconButton, Button, MenuItem } from "@mui/material";
import Select from 'react-select';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption , Papa, getLocalStorageKey} from "../common/common";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
import { Edit as EditIcon } from "@mui/icons-material";
import SendIcon from '@mui/icons-material/Send';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Show, List, TabbedShowLayout, Tab, Link, usePermissions } from "react-admin";
import { useNavigate } from 'react-router-dom';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux'

const DiscountSchemesCreateTwo = (props) => {
  // var urlId = window.location.href.substring(
  //   window.location.href.lastIndexOf("/") + 1
  // );
  let webUrl = window.location.href;

  var words = webUrl.split('/');
  var searcher = 'discount_scheme_assignment';
  var numberIndex = words.findIndex((word) => word == searcher);
  var urlId = words[numberIndex + 1];

  const [discountSchemeID] = useState(urlId);
  const [assignedList, setAssignedList] = useState([]);
  const [assignedColumns, setAssignedColumns] = useState([]);

  const [unAssignedList, setUnAssignedList] = useState([]);
  //   const [unAssignedColumns, setUnAssignedColumns] = useState([]);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCountUnAssigned, setRowCountUnAssigned] = useState(0);
  const [pageUnAssigned, setPageUnAssigned] = useState(1);
  const [rowCountAssigned, setRowCountAssigned] = useState(0);
  const [pageAssigned, setPageAssigned] = useState(1);
  const [soldToSelectedList,setSoldToSelectedList] = useState([])
  const [unassignedListTotal,setUnassignedListTotal] = useState(0)

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paginationAssigned, setPaginationAssigned] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  // console.log('pagination pagination pagination', pagination);
  const [businessOptionList, setBusinessOptionList] = useState([]);
  const [businessOptionCompareList, setBusinessOptionCompareList] = useState([])

  const capitalizeEachWord = (str) => {
    const words = str.replace(/_/g, " ").split(" ");
    const capitalizedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(" ");
  };

  const assignedListApi = (options, apiUrl, isPageSize) => {
    fetch(
      `${apiUrl}/voucher_assigend_list?discount_scheme_id=${discountSchemeID}&page=${
        pagination.pageIndex + 1
      }&per_page=${pagination.pageSize}`,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===> voucher_assigend_list ", jsonD.data);
        if (jsonD.data.length > 0) {
          let columnIds = Object.keys(jsonD.data[0]);
          columnIds = columnIds.filter(item => item !== 'id')
          const columnMapping = columnIds.map((id) => {
            return {
              accessorKey: id,
              header: capitalizeEachWord(id),
            };
          });
          setAssignedColumns(columnMapping);
          const data = jsonD.data;
          let modifiedStatus = data.map(data =>
              data.is_used = JSON.stringify(data.is_used));
          if (isPageSize) {
            setAssignedList([...jsonD.data]);
          }else {
            setAssignedList((assignedList) => [...assignedList, ...jsonD.data]);
          }
          setRowCountAssigned(jsonD.total);
        }
      });
  };

  const unAssignedListApi = (options, apiUrl, isPageSize) => {
    console.log("llllllllllllllllllllllllllll", pagination, isPageSize);
    fetch(
      `${apiUrl}/voucher_unassigend_list?discount_scheme_id=${discountSchemeID}&page=${
        pagination.pageIndex + 1
      }&per_page=${pagination.pageSize}`,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        setUnassignedListTotal(jsonD.total);
        if (jsonD.data.length > 0) {
          const columnIds = Object.keys(jsonD.data[0]);
          const columnMapping = columnIds.map((id) => {
            return {
              accessorKey: id,
              header: capitalizeEachWord(id),
            };
          });
          // setUnAssignedColumns(columnMapping)
          if (isPageSize) {
            setUnAssignedList([
              ...jsonD.data,
            ]);
          }else {
            setUnAssignedList((unAssignedList) => [
              ...unAssignedList,
              ...jsonD.data,
            ]);

          }
          setRowCountUnAssigned(jsonD.total);
          console.log("jsonD ===> voucher_unassigend_list ", jsonD.data);
        }
      });
  };

  const soBusinessListApi = (options, apiUrl) => {
    fetch(`${apiUrl}/so_business_list?discount_scheme_id=${discountSchemeID}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        if (jsonD.data) {
          let labelData = jsonD.data.map((d) => d.label);
          console.log("jsonD ===> so_business_list,,,,");
          setBusinessOptionList([...labelData]);
          setBusinessOptionCompareList([...labelData]);
        }
      });
  };

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    assignedListApi(options, apiUrl, false);
    unAssignedListApi(options, apiUrl, false);
    soBusinessListApi(options, apiUrl);
    // fetch(`${apiUrl}/voucher_assigend_list?discount_scheme_id=${discountSchemeID}&page=1`, options)
    //   .then((res) => {
    //     return res.json();
    //   })
    //   .then((jsonD) => {
    //     console.log("jsonD ===> voucher_assigend_list ", jsonD.data);
    //     if (jsonD.data.length > 0) {
    //         const columnIds = Object.keys(jsonD.data[0]);
    //         const columnMapping = columnIds.map((id)=> {
    //             return {
    //                 'accessorKey': id,
    //                 'header' : capitalizeEachWord(id)
    //             }
    //         }
    //         )
    //         setAssignedColumns(columnMapping)
    //         setAssignedList([...jsonD.data])
    //     }

    //   });

    // fetch(`${apiUrl}/voucher_unassigend_list?discount_scheme_id=${discountSchemeID}&page=1`, options)
    // .then((res) => {
    //     return res.json();
    // })
    // .then((jsonD) => {
    //     if(jsonD.data.length > 0){
    //         const columnIds = Object.keys(jsonD.data[0]);
    //         const columnMapping = columnIds.map((id)=> {
    //             return {
    //                 'accessorKey': id,
    //                 'header' : capitalizeEachWord(id)
    //             }
    //         }
    //         )
    //         // setUnAssignedColumns(columnMapping)
    //         setUnAssignedList([...jsonD.data]);
    //         console.log("jsonD ===> voucher_unassigend_list ", jsonD.data);
    //     }
    // });

    // fetch(`${apiUrl}/so_business_list`, options)
    //   .then(res => {
    //     return res.json();
    //   }).then(jsonD => {
    //     if (jsonD.data) {
    //         let labelData= jsonD.data.map(d => d.label)
    //         console.log('jsonD ===> so_business_list,,,,')
    //         setBusinessOptionList([...labelData])
    //     }
    //   });
  }, []);

  const unAssignedColumns = useMemo(
    //column definitions...
    () => [
      // {
      //   accessorKey: 'id',
      //   header: 'Id',
      //   enableEditing: false,
      // },
      {
        accessorKey: "discount_voucher",
        header: "Discount Voucher",
        enableEditing: false,
      },
      {
        accessorKey: "business_id",
        header: "Sold To Id",
        // muiTableBodyCellEditTextFieldProps: {
        //     select: true, //change to select for a dropdown
        //     children: businessList.map((business) => (
        //     <MenuItem key={business} value={business}>
        //         {business}
        //     </MenuItem>
        //     )),
        // },
        Edit: ({ row }) => {
          return (
            businessOptionList && (
              <>
              <Autocomplete
                options={businessOptionList}
                autoComplete
                disableClearable={true}
                renderInput={(params) => (
                  <TextField {...params} label="select sold to" />
                )}
                renderOption={(props, option) => {
                  return(
                  <li {...props} key={props.id}>
                    {option}
                  </li>
                  )
                }}
                onChange={(event, value) => {
                  console.log("rowwwwwwwwwwww", soldToSelectedList[row.id], row.id , value);
                  row._valuesCache["business_id"] = value;
                  let tempData = soldToSelectedList[row.id];
                  let selectedData = [...soldToSelectedList];
                  const businessNew = [...businessOptionList];
                  
                  // if (tempData != undefined || tempData != null) {
                  //   console.log('yahahahahahhaha',tempData);
                  //   if (!businessNew.includes(tempData)) {
                  //     console.log('tempData tempData tempData tempData tempData',tempData , soldToSelectedList , row.id);
                  //     businessNew.splice(row.id + 1, 0, tempData);
                  //     selectedData.splice(tempData,1);
                  //   }
                  // }



                  // selectedData[row.index] = value
                  // setSoldToSelectedList(selectedData)

                  // businessNew.splice(value, 1);
                  // setBusinessOptionList(businessNew);
                  
                  if (tempData == undefined || tempData == '' || tempData == '') {
                    selectedData[row.index] = value
                    // selectedData.splice(row.index,0,value)
                    setSoldToSelectedList(selectedData)

                    const index = businessNew.indexOf(value);
                    businessNew.splice(index, 1);
                    setBusinessOptionList(businessNew);
                    console.log('lllllllllllllllllllll',selectedData, businessNew);                    
                  }else{
                    selectedData[row.index] = value
                    // selectedData.splice(row.index,0,value)
                    const index = businessNew.indexOf(value);
                    businessNew.splice(index, 1);
                    let findIndex = businessOptionCompareList.findIndex(
                      (item) => item == tempData
                    )
                    businessNew.splice(findIndex, 0, tempData);
                    // selectedData.splice(tempData,1);
                    setSoldToSelectedList(selectedData)
                    setBusinessOptionList(businessNew);
                    console.log('yahahahahahhaha',selectedData, businessNew);
                  }
                  
                  // const newData = [...businessOptionList];
                  // newData.splice(row._valuesCache.business_id, 1);
                  // setBusinessOptionList(newData);
                  
                  // row.original['business_id'] = value; //can be used
                }}
              />
              {/* <button onClick={()=>{
                let findIndex = businessOptionCompareList.findIndex(
                  (item) => item == row._valuesCache.business_id
                )
                businessOptionList.splice(findIndex, 0, row._valuesCache.business_id);
                console.log('cccccccccccccclick', businessOptionCompareList, findIndex ,row._valuesCache.business_id);
              }}>clear</button> */}
              </>
            )
          );
        },
      },
    ],
    [businessOptionList, soldToSelectedList, businessOptionCompareList]
    //end
  );

  //   const assignedColumns = useMemo(
  //     //column definitions...
  //     () =>

  //         [
  //             {
  //                 accessorKey: 'firstName',
  //                 header: 'First Name',
  //             },
  //             {
  //                 accessorKey: 'lastName',
  //                 header: 'Last Name',
  //             },
  //             {
  //                 accessorKey: 'address',
  //                 header: 'Address',
  //             },
  //             {
  //                 accessorKey: 'city',
  //                 header: 'City',
  //             },
  //             {
  //                 accessorKey: 'state',
  //                 header: 'State',
  //             },
  //         ],

  //     [],
  //     //end
  //   );

  // const data = [
  //     {
  //       firstName: 'Dylan',
  //       lastName: 'Murray',
  //       address: '261 Erdman Ford',
  //       city: 'East Daphne',
  //       state: 'Kentucky',
  //     },
  //     {
  //       firstName: 'Raquel',
  //       lastName: 'Kohler',
  //       address: '769 Dominic Grove',
  //       city: 'Columbus',
  //       state: 'Ohio',
  //     },
  //     {
  //       firstName: 'Ervin',
  //       lastName: 'Reinger',
  //       address: '566 Brakus Inlet',
  //       city: 'South Linda',
  //       state: 'West Virginia',
  //     },
  //     {
  //       firstName: 'Brittany',
  //       lastName: 'McCullough',
  //       address: '722 Emie Stream',
  //       city: 'Lincoln',
  //       state: 'Nebraska',
  //     },
  //     {
  //       firstName: 'Branson',
  //       lastName: 'Frami',
  //       address: '32188 Larkin Turnpike',
  //       city: 'Charleston',
  //       state: 'South Carolina',
  //     },
  //   ];

  const voucherAssignmentApi = (dataToSend) => {
    setIsLoading(true);
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "PATCH";
    const stringyData = dataToSend.map((v) => ({
      ...v,
      discount_scheme_id: discountSchemeID,
    }));
    options.body = JSON.stringify(stringyData);
    fetch(`${apiUrl}/discount_voucher_assignment`, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json reply", json);
        setIsLoading(false);
        // this.props.history.push("/");
        Swal.fire({
          text: "Coupon assigned successfully",
          confirmButtonText: `OK`,
          icon: "success",
        }).then((result) => {
          // console.log('result inside Swal.fire ===>', result);
          window.location.reload();
          // const options = CommonHeaderOption();
          // const apiUrl = RUN_TIME_API_ENDPOINT;
          // options.method = "GET";
          // assignedListApi(options,apiUrl);
          // unAssignedListApi(options,apiUrl);
        });
      });
  };

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    //do something when the pagination state changes
    const countEnd = (pagination.pageIndex + 1) * pagination.pageSize;

    if (rowCountUnAssigned != 0) {
      // if (countEnd >= rowCountUnAssigned ) {
      console.log("hihihihihi fyyyyuyyuii", countEnd, rowCountUnAssigned);
      // const pageIncrease = pageUnAssigned + 1 ;
      // setPageUnAssigned(pageIncrease)
      unAssignedListApi(options, apiUrl, false);
      // }
    }
  }, [pagination.pageIndex]);

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    //do something when the pagination state changes
    const countEnd = (pagination.pageIndex + 1) * pagination.pageSize;

    if (rowCountUnAssigned != 0) {
      // if (countEnd >= rowCountUnAssigned ) {
      console.log("hihihihihi fyyyyuyyuii", countEnd, rowCountUnAssigned);
      // const pageIncrease = pageUnAssigned + 1 ;
      // setPageUnAssigned(pageIncrease)
      unAssignedListApi(options, apiUrl,true);
      // }
    }
  }, [pagination.pageSize]);

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    //do something when the pagination state changes
    const countEnd = (pagination.pageIndex + 1) * pagination.pageSize;

    if (rowCountAssigned != 0) {
      // if (countEnd >= rowCountUnAssigned ) {
      console.log("paaaapppppiiiiiiiiiiiii zzzAA", countEnd, rowCountAssigned);
      // const pageIncrease = pageUnAssigned + 1 ;
      // setPageUnAssigned(pageIncrease)
      assignedListApi(options, apiUrl, false);
      // }
    }
  }, [pagination.pageIndex]);

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    //do something when the pagination state changes
    const countEnd = (pagination.pageIndex + 1) * pagination.pageSize;

    if (rowCountAssigned != 0) {
      // if (countEnd >= rowCountUnAssigned ) {
      console.log("paaaapppppiiiiiiiiiiiii", countEnd, rowCountAssigned);
      // const pageIncrease = pageUnAssigned + 1 ;
      // setPageUnAssigned(pageIncrease)
      assignedListApi(options, apiUrl, true);
      // }
    }
  }, [pagination.pageSize]);


 ///////////////////////////////////////////////////////////////// 

 const navigate = useNavigate();
 const permissions = usePermissions();
 const [showLoader, setShowLoader] = useState(false);
 const [successMsg, setSuccessMsg] = useState(false);
 const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
 const [errorMsg, setErrorMsg] = useState(false);
 const [errorMsgText, setErrorMsgText] = useState(null);
 const [type, setType] = useState('Country');
 const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
 const [parsedCSVdata, setParsedCSVdata] = useState([]);
 const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
 const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
 const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0);
 const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false);
 const [saleOffList, setSaleOffList] = useState([]);
 const [originalList, setOriginalList] = useState([]);


 useEffect(() => {
   const options = CommonHeaderOption();
   const apiUrl = RUN_TIME_API_ENDPOINT;
   options.method = 'GET';
   fetch(`${apiUrl}/so_business_list?discount_scheme_id=${discountSchemeID}`, options)
     .then(res => {
       return res.json();
     }).then(jsonD => {
       console.log('jsonD ===>', jsonD)
       let obj = {};
       obj.sap_order_materials = jsonD.data;
       obj.loadingShow = false;
       setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
       setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
     });
 }, [])

 const handleChange = e => {
   console.log('hiiii', e);
   console.log('saleOffNameSapCode in handleChange', saleOffNameSapCode);
   const arr = [...originalList]

   let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
   if (e === null) {
     result = [...originalList];
     setSaleOffList([]);
   }
   setSaleOffList(e);
   setSaleOffNameSapCode(result);
 };

 const formSave = (e) => {
  e.preventDefault();
  setShowLoader(true);
  setSaveButtonDisabled(false);
  // this.setState({
  //   showLoader: true,
  //   saveButtonDisabled: false

  // });
  // const checkType = type === 'Sales' || type === 'Region' || type === 'customerGroup' ?
  //   'Business' : type;
  const formData = {
    discount_scheme_id: discountSchemeID,
    name_sap_code: saleOffList,
  }
  console.log('formData>>>>>>', formData);

  const apiUrl = RUN_TIME_API_ENDPOINT;
  const options = CommonHeaderOption();
  options.method = 'PATCH';
  options.body = JSON.stringify({ formData });

  return fetch(`${apiUrl}/coupon_assign_soldtos`, options)
    .then(res => {
      console.log('res12...........', res)
      if (res) {
        return res.json();
      }
    }
    )
    .then(res => {
      if (res.errorMsg) {
        setErrorMsg(true);
        setShowLoader(false);
        setErrorMsgText(res.errorMsg);
        setTimeout(() => {
          setErrorMsg(false);
          setSaveButtonDisabled(true);
        }, 3000)
      } else {
        console.log('res...........', res)
        setShowLoader(false);
        setSaveButtonDisabled(true);
        setSuccessMsg(true);
        setTimeout(() => {
          setSuccessMsg(false);
        }, 2000)
        setTimeout(() => {
          navigate(`/discount_schemes/${discountSchemeID}/show`);
        }, 3000)
        console.log('res', res);
      }

    }).catch(error => {
      console.log(error);
    })

}


 const selectHandleChange = (event) => {
   setType(event.target.value)
 }


const handleFile = e => {
  let file = null;
  file = e.target.files[0];
  const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
  if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined || fileType.toLowerCase() !== 'csv') {
    Swal.fire({
      text: 'Please choose a valid .csv file.',
      confirmButtonText: `OK`,
      icon: 'error'
    });
    file = null;
    console.log('bad file');
  } else {
    console.log([e.target.name], e.target.files[0]);
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const checkValidHeader = Object.keys(results.data[0]);
        // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
        if (checkValidHeader.includes('COMPANYNAME') && checkValidHeader.includes('SAPID')) {
          const parseddata = permissions === 'isSap' ?
            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + '-0000' + item.SAPID, label: item.COMPANYNAME + '-0000' + item.SAPID, sap: '0000' + item.SAPID.trim() })) :
            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.SAPID, label: item.COMPANYNAME + ' ' + item.SAPID, sap: item.SAPID.trim() }));
          console.log(parseddata);
          let pasrsedSimilarData = [];
          pasrsedSimilarData = originalList.filter(a1 => parseddata.some(a2 => a1.sap === a2.sap));
          if (pasrsedSimilarData && pasrsedSimilarData.length) {
            const similarArray = saleOffList !== null ? saleOffList.filter(({ sap: id1 }) =>
              !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)) : [];
              setSaleOffList([...similarArray, ...pasrsedSimilarData]);
              setPasrsedSimilarDataLength(pasrsedSimilarData.length);
            // this.setState({ saleOffList: [...similarArray, ...pasrsedSimilarData], pasrsedSimilarDataLength: pasrsedSimilarData.length })
          }
          const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.sap !== a2.sap));
          if (pasrsedDifferentData && pasrsedDifferentData.length) {
            console.log(pasrsedDifferentData, pasrsedDifferentData.length)
            setUnregisteredRetailers([...pasrsedDifferentData])
            setPasrsedDifferentDataLength(pasrsedDifferentData.length);
            // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
          }
          console.log('seprated', pasrsedSimilarData, pasrsedDifferentData);
          setParsedCSVdata([...parseddata])
          // this.setState({ parsedCSVdata: [...parseddata] });
        } else {
          file = null;
          Swal.fire({
            text: 'File headers do not match. Kindly download and refer the sample file.',
            confirmButtonText: `OK`,
            icon: 'error'
          });
        }
      }
    });
  }
}

const toggleUnregisteredRetailers = () => {
  setUnregisteredRetailersToggle(!unregisteredRetailersToggle)
  // this.setState({ unregisteredRetailersToggle: !this.state.unregisteredRetailersToggle })
}

const cancelClick = () => {
  setSaleOffList([]);
  setSaleOffNameSapCode(originalList);
  setUnregisteredRetailers([]);
  setPasrsedSimilarDataLength(0);
  setPasrsedDifferentDataLength(0);
}

const alterForUnassignedTotal = () => {
  Swal.fire({
    text: `You have selected more sold-to's than the available coupons!
    Please deselect some retailers so that you have less than or equal to the available coupons.`,
    confirmButtonText: `Close`,
    icon: "error",
  })
}

 //////////////////////////////////////////////////////////////////////

  return (
    <div> 
      <div className="ds-ls-btn-grp">
        <Button
          className="row-align-center ds-ls-btn"
          component={Link}
          to={{
              pathname: `/discount_schemes`
          }}
        ><FormatListBulletedIcon className="ds-ls-icon" />List</Button>
          <Button
          className="row-align-center ds-ls-btn"
          component={Link}
          to={{
              pathname: `/discount_schemes/${discountSchemeID}/show`,
          }}
        ><VisibilityIcon className="ds-ls-icon" />Show</Button>
      </div>
      <Tabs>
        <TabLink className="ds-assignment-tab" to="tab1">Coupons not assigned (single)</TabLink>
        <TabLink className="ds-assignment-tab" to="tab3">Bulk assign coupons</TabLink>
        <TabLink className="ds-assignment-tab" to="tab2">Coupons assigned (single)</TabLink>
        <TabContent for="tab1">
          {unAssignedColumns && unAssignedList && (
            <MaterialReactTable
              columns={unAssignedColumns}
              data={unAssignedList.length > 0 ? unAssignedList : []}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              enableHiding={false}
              positionActionsColumn="last"
              enableFilters={false}
              enableSorting={false}
              enableColumnActions={false}
              enableRowSelection
              enableGlobalFilter={false}
              getRowId={(row) => row.phoneNumber}
              initialState={{ showColumnFilters: false, density: 'compact' }}
              manualFiltering
              manualPagination
              manualSorting
              editingMode="table"
              enableEditing
              // muiTableBodyCellEditTextFieldProps={({ cell }) => ({
              //     //onBlur is more efficient, but could use onChange instead
              //     // select: true,
              //     onBlur: (event) => {
              //     //   handleSaveCell(cell, event.target.value);
              //     },
              //     variant: 'outlined',
              // })}
              renderTopToolbarCustomActions={({ table }) => {
                // const handleActivate = () => {
                //     console.log('alala ,',table ,table.getSelectedRowModel().flatRows);
                // table.getSelectedRowModel().flatRows.map((row) => {
                //     // console.log('activating ' + row.getValue('lastName'), row.original);
                //     console.log('activating ' , row.original);
                // });
                // };

                const voucherBulkAssignmentApi = () => {
                  setIsLoading(true);
                  const options = CommonHeaderOption();
                  const apiUrl = RUN_TIME_API_ENDPOINT;
                  options.method = "PATCH";

                  let selectedData = table.getSelectedRowModel().flatRows.map(
                    (row) =>
                      // console.log('activating ' + row.getValue('lastName'), row.original);
                      row._valuesCache
                  );

                  const stringyData = selectedData.map((v) => ({
                    ...v,
                    discount_scheme_id: discountSchemeID,
                  }));
                  const isAnyNull = Object.keys(stringyData).some(function (k) {
                    return stringyData[k].business_id == null;
                  });
                  console.log(
                    "alala ,",
                    stringyData,
                    table.getSelectedRowModel().flatRows,
                    isAnyNull
                  );
                  if (isAnyNull) {
                    Swal.fire({
                      text: "Please select customer sold-to for the selected discount vouchers",
                      confirmButtonText: `Close`,
                      icon: "error",
                    });
                    setIsLoading(false);
                  } else {
                    if (table.getSelectedRowModel().flatRows.length == 0) {
                      Swal.fire({
                        text: "Please select customer sold-to for the selected discount vouchers",
                        confirmButtonText: `Close`,
                        icon: "error",
                      });
                      setIsLoading(false);
                    } else {
                      options.body = JSON.stringify(stringyData);
                      fetch(`${apiUrl}/discount_voucher_assignment`, options)
                        .then((res) => {
                          return res.json();
                        })
                        .then((json) => {
                          console.log("json reply", json);
                          setIsLoading(false);
                          Swal.fire({
                            text: "Coupon assigned successfully",
                            confirmButtonText: `OK`,
                            icon: "success",
                          }).then((result) => {
                            // const options = CommonHeaderOption();
                            // const apiUrl = RUN_TIME_API_ENDPOINT;
                            // options.method = "GET";
                            // assignedListApi(options,apiUrl);
                            // unAssignedListApi(options,apiUrl);
                            window.location.reload();
                          });
                        });
                    }
                  }
                };

                return (
                  <>
                  {
                  unAssignedList.length > 0 &&
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <Button
                      color="success"
                      // disabled={!table.getIsSomeRowsSelected()}
                      onClick={voucherBulkAssignmentApi}
                      variant="contained"
                    >
                      Bulk Send
                    </Button>
                  </div>
                  }
                  </>
                );
              }}
              muiToolbarAlertBannerProps={
                isError
                  ? {
                      color: "error",
                      children: "Error loading data",
                    }
                  : undefined
              }
              enableRowActions
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <IconButton
                    color="secondary"
                    onClick={() => {
                      console.log(
                        "rwo",
                        row._valuesCache,
                        row._valuesCache.business_id
                      );
                      //   table.setEditingRow(row);
                      let dataToSend = [row._valuesCache];
                      if (
                        row._valuesCache.business_id == null ||
                        row._valuesCache.business_id == undefined
                      ) {
                        Swal.fire({
                          text: "Please select customer sold-to for the selected discount vouchers",
                          confirmButtonText: `Close`,
                          icon: "error",
                        });
                      } else {
                        voucherAssignmentApi(dataToSend);
                      }
                    }}
                  >
                    <SendIcon />
                  </IconButton>
                </Box>
              )}
              onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={rowCountUnAssigned}
              state={{
                columnFilters,
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
            />
          )
          // :
          // <div>no data</div>
          }
        </TabContent>
        <TabContent for="tab3">


            {
              // type === 'Business' &&
              <div className="unassign-bulklist">
                <label className="select-label">Choose sold-to's<sup className="asterisk">*</sup> (Select at least one, and maximum {unassignedListTotal}) (Retailers available for selection: {unassignedListTotal - (saleOffList == null ? 0 : saleOffList?.length)})</label>
                <div className="select-retailer">
                  <Select
                    value={saleOffList}
                    onChange={handleChange}
                    options={saleOffNameSapCode}
                    isMulti
                  />
                  <button onClick={cancelClick}>Clear</button>
                </div>
                <div className="csv-file-upload-container target-upload-container"><label>Upload File</label>
                  {/* <input type="file" accept=".csv" name="flies[]" /> */}
                  <input type="file" id="file" accept=".csv" onChange={handleFile} />
                  <div className="valid-file-upload">
                    <p>Instructions :</p>
                    <ul>
                      <li>Only CSV files are allowed with Comma as separator.</li>
                    </ul>
                  </div>
                  <div className="upload-file-format-download">
                    <p>To get upload file format. <a
                      href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                      target="_blank">Click here</a> to download</p>
                  </div>
                </div>

                {
                  pasrsedSimilarDataLength > 0 ||
                    pasrsedDifferentDataLength > 0 ?
                    <div className="csv-result-container">
                      <label>CSV Result</label>
                      <div className="csv-result">
                        <div>
                          <p onClick={toggleUnregisteredRetailers}>
                            {pasrsedSimilarDataLength} retailers found, {pasrsedDifferentDataLength} retailers unregistered.
                            {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd retailers' : ''}
                            {
                              pasrsedDifferentDataLength > 0 ?
                                <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                                : ''
                            }
                          </p>
                          {
                            pasrsedDifferentDataLength > 0 ?
                              <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                                <React.Fragment>
                                  {
                                    unregisteredRetailers.map(item => (
                                      <p key={item.id}>{item.label}</p>
                                    ))
                                  }
                                </React.Fragment>
                              </div>
                              : ''
                          }
                        </div>
                      </div>
                    </div> :
                    ''
                }


              </div>
              
            }

            {
              saleOffList!==null && saleOffList?.length > unassignedListTotal &&
              alterForUnassignedTotal()
            }

            {saveButtonDisabled &&
            <div className="so-save-button">
              <button className={( saleOffList == null ||saleOffList?.length <=0 || saleOffList?.length > unassignedListTotal ) ? 'disable-save' : ''}
                disabled={( saleOffList == null ||saleOffList?.length <=0 || saleOffList?.length > unassignedListTotal)}
                onClick={(e) => formSave(e)}>Save</button>
            </div>
            }

          {showLoader &&
            <div className="save-loader" />
          }
          {successMsg &&
            <div className="so-updated" >
              Successfully Created </div>
          }
          {errorMsg &&
            <div className="so-email-exist" >
              {errorMsgText}</div>
          }

        </TabContent>
        <TabContent for="tab2">
          {assignedColumns && assignedList && (
            <MaterialReactTable
              className="mrt-table2"
              columns={assignedColumns}
              data={assignedList}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              enableHiding={false}
              enableFilters={false}
              enableSorting={false}
              enableColumnActions={false}
              enableRowSelection={false}
              getRowId={(row) => row.phoneNumber}
              initialState={{ showColumnFilters: false, density: 'compact' }}
              manualFiltering
              manualPagination
              manualSorting
              muiToolbarAlertBannerProps={
                isError
                  ? {
                      color: "error",
                      children: "Error loading data",
                    }
                  : undefined
              }
              onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={rowCountAssigned}
              state={{
                columnFilters,
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
            />
          )}
        </TabContent>
      </Tabs>
    </div>
  );
};

export default DiscountSchemesCreateTwo;
